<script setup>
const menuList = [
  {
    title: 'Home',
    key: 'home',
    path: '/dashboard',
  },
  {
    title: '고객관리',
    key: 'customers',
    sub: [
      {
        title: '전체 고객 목록',
        path: '/customers',
        key: 'customer-list',
      },
      {
        title: '리포트 발송 목록',
        path: '/reports/send',
        key: 'reports-send',
      },
      {
        title: '자동 발송 이력',
        path: '/reports/sms-list',
        key: 'reports-sms-list',
      },
    ],
  },
  {
    title: '사용자 관리',
    key: 'pi-user-edit',
    admin: true,
    sub: [
      {
        title: '계정관리',
        key: 'users',
        path: '/users',
      },
      {
        title: '리포트 발행 알림 수신자 관리',
        key: 'report-notification-recipients',
        path: '/users/report-notification-recipients',
      },
    ],
  },
  {
    title: '공지사항/소식',
    key: 'notices',
    path: '/notices',
  },
]
const auth = useAuth()
const isAdmin = computed(() => auth.userLevel === 'admin')
const availableMenuList = computed(() =>
  menuList.filter((menu) => (menu.admin && isAdmin.value) || !menu.admin),
)
const { $auth } = useNuxtApp()
const menuStatus = reactive(Array(menuList.length).fill(false))
const clickMenu = (index) => {
  if (!availableMenuList.value[index].sub)
    return navigateTo({ path: availableMenuList.value[index].path })
  return (menuStatus[index] = !menuStatus[index])
}
</script>
<template>
  <aside
    class="w-[17.5rem] h-full | flex flex-col items-start justify-between | bg-white"
  >
    <section>
      <NuxtLink class="w-[17.5rem] p-8 flex gap-[.125rem] items-center" to="/">
        <img
          class="w-[1.875rem] h-[1.875rem]"
          src="@/assets/images/icon/ico-genoplan-primary.svg"
          alt=""
        />
        <span class="font-bold text-20 text-grey-700">Genoplan MD</span>
      </NuxtLink>
      <div class="mx-8 mt-10 mb-6 | flex items-center gap-[.625rem]">
        <img src="@/assets/images/navBar/ht-icon-hi.svg" alt="" />
        <p class="text-18">
          <b data-sentry-mask>{{ auth.name }}</b
          >님 안녕하세요.
        </p>
      </div>
      <nav class="flex flex-col">
        <div
          v-for="(menu, i) of availableMenuList"
          :key="menu.title"
          class="border-t border-grey-100 last:border-b"
        >
          <div class="flex flex-col !h-auto text-14 p-0 | focus:z-10">
            <button
              class="w-full | flex items-center gap-2 | !py-[1.125rem] px-8 hover:bg-grey-50 hover:!text-grey-900"
              :data-testid="`side-nav__${menu.key}`"
              @click="() => clickMenu(i)"
            >
              <i
                v-if="menu.key.startsWith('pi')"
                class="pi pi-user-edit text-grey-500 text-18 w-6 h-6"
              />
              <img
                v-else
                :src="`/images/navBar/ht-icon-${menu.key}.svg`"
                alt=""
              />
              <p class="grow text-left">{{ menu.title }}</p>
              <img
                v-if="menu.sub"
                class="w-[1.125rem]"
                :class="menuStatus[i] ? '' : 'rotate-180'"
                src="@/assets/images/icon/ht-icon-arrow-up.svg"
                alt=""
              />
            </button>
            <TransitionExpand v-if="menu.sub">
              <div v-show="menuStatus[i]" class="w-full">
                <NuxtLink
                  v-for="sub of menu.sub"
                  :key="sub.title"
                  :to="sub.path"
                  :data-testid="`side-nav__${sub.key}`"
                  class="block w-full text-left py-[1.125rem] pl-16 | hover:bg-grey-50 hover:text-grey-900"
                >
                  {{ sub.title }}
                </NuxtLink>
              </div>
            </TransitionExpand>
          </div>
        </div>
      </nav>
    </section>
    <section
      class="flex items-center justify-center | py-[.625rem] mx-auto | text-grey-500 text-14"
    >
      <NuxtLink
        class="flex items-center | p-4"
        to="/account"
        data-testid="side-nav__account"
      >
        <img class="w-6" src="@/assets/images/icon/ht-icon-edit.svg" alt="" />
        내 계정관리
      </NuxtLink>
      <span class="text-grey-100">|</span>
      <button
        class="flex items-center | p-4 !text-grey-500 font-normal"
        @click="$auth.requestLogout"
      >
        <img
          class="w-6"
          src="@/assets/images/icon/ht-icon-sign-out.svg"
          alt=""
        />로그아웃
      </button>
    </section>
  </aside>
</template>
<style scoped>
@reference '~/vue-components/styles/base.css';

.nuxt-link-active {
  @apply bg-grey-50;
}
</style>
